import React, { useState, useEffect, useRef } from 'react';

const LazyBackgroundImage = ({ src, placeholder, children, k, altText }) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
      }
    }, { threshold: 0.1 });

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) { // eslint-disable-next-line
        observer.unobserve(ref.current);
      }
    };
  }, []);

  return (
    <picture>
      <source srcSet={isVisible ? src[1] : placeholder} media="(max-width: 768px)" width="363" height="350"/>
      <source srcSet={isVisible ? src[0] : placeholder} media="(min-width: 768px)" width="616" height="350"/>
      <img className="box-inner"
        ref={ref}
        src={isVisible ? src[0] : placeholder}
        alt={altText}
        title={altText}
        width="616"
        height="350"
        {...(k !== 0 && { loading: 'lazy' })}
        {...(k === 0 && { fetchpriority: 'high' })}
      />
    </picture>
  );
};

export default LazyBackgroundImage;
